import { useMutation } from "react-query";
import downloadSkuLoanCsv from "../services/downloadSkuLoanCsv";

function useDownloadSkuLoanCsv() {
  return useMutation(["download-sku-loan-csv"], downloadSkuLoanCsv);
}

export default useDownloadSkuLoanCsv;
